module.exports = __webpack_public_path__ + "static/media/img-churrasqueira.e42d2922.jpg";